import { FormikProps } from 'formik';
import React from 'react';
import Banner from '@cpg-its/ads.containers.banner';
import { PensionEnrollmentInfo } from '../models/pension-enrollment-model';
import { PensionEnrollmentSelectedPlan } from './pension-enrollment-selected-plan';
import { PensionEnrollmentEmployeeContribution } from './pension-enrollment-employee-contribution';
import { PensionEnrollmentEmployerContributions } from './pension-enrollment-employer-contributions';
import { PensionEnrollmentFormValues } from '../models/pension-enrollment-form-model';
import { PensionEnrollmentProps } from '../../../models/arc-epi-props';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { WysiwygWithReactLink } from '../../../../../global/components/wysiwyg-with-react-link';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { adjustForLocalOffset, getCurrentTimeNY } from '../../../../../global/helpers/date-helpers';

interface Props {
    formProps: FormikProps<PensionEnrollmentFormValues>;
    pensionInfo: PensionEnrollmentInfo;
    pensionEnrollmentProps: PensionEnrollmentProps;
}

export function PensionEnrollmentPlanDetails(props: Props) {
    const { formProps, pensionInfo, pensionEnrollmentProps } = props;
    const selectedPlan = pensionInfo?.plans?.find(plan => plan.pbpor_id === formProps.values.plan);

    return (
        <>
            <PensionEnrollmentSelectedPlan
                pensionEnrollmentProps={pensionEnrollmentProps}
                formProps={formProps}
                selectedPlan={selectedPlan}
            />

            <PensionEnrollmentEmployeeContribution
                pensionEnrollmentProps={pensionEnrollmentProps}
                formProps={formProps}
                selectedPlan={selectedPlan}
            />

            <PensionEnrollmentEmployerContributions
                pensionEnrollmentProps={pensionEnrollmentProps}
                selectedPlan={selectedPlan}
            />
            <DividerSection removeDivider>
                <FormField
                    name='agreement'
                    label={pensionEnrollmentProps?.confirmLabel}
                    component='checkBox'
                    touched={formProps.touched}
                    errors={formProps.errors}
                    value={formProps?.values?.agreement ?? false}
                    checked={formProps?.values?.agreement ?? false}
                />
                <div className='rich-text'>
                    <WysiwygWithReactLink content={pensionEnrollmentProps?.confirmMessage} />
                </div>
                {
                    adjustForLocalOffset(new Date(selectedPlan.plan_effective_date)) > getCurrentTimeNY() &&
                    <ContentSpacer>
                        <Banner
                            banner={{
                                type: 'warning',
                                label: <div className='rich-text'>
                                    <WysiwygWithReactLink content={pensionEnrollmentProps?.planHasFutureEffectiveDateWarningMessage} />
                                </div>,
                            }}
                        />
                    </ContentSpacer>
                }

            </DividerSection>
        </>
    );
}